import React from "react";

export default function SubscriberHome() {
  return <div>SubscriberHome</div>;
}
